import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const SafetyProtocolCard = ({ protocol }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-conservation">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-6 flex items-center justify-between hover:bg-muted/5 animation-organic"
      >
        <div className="flex items-center gap-4">
          <div className={`p-3 rounded-lg ${protocol?.priority === 'high' ? 'bg-error/10' : protocol?.priority === 'medium' ? 'bg-warning/10' : 'bg-info/10'}`}>
            <Icon 
              name={protocol?.icon} 
              size={24} 
              className={protocol?.priority === 'high' ? 'text-error' : protocol?.priority === 'medium' ? 'text-warning' : 'text-info'}
            />
          </div>
          <div className="text-left">
            <h3 className="text-card-foreground font-semibold text-lg">{protocol?.title}</h3>
            <p className="text-muted-foreground text-sm">{protocol?.category}</p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={24} 
          className="text-muted-foreground"
        />
      </button>
      {isExpanded && (
        <div className="px-6 pb-6 border-t border-border">
          <div className="pt-4 space-y-4">
            <p className="text-card-foreground">{protocol?.description}</p>
            
            <div>
              <h4 className="text-card-foreground font-semibold mb-2">Steps to Follow:</h4>
              <ol className="space-y-2">
                {protocol?.steps?.map((step, index) => (
                  <li key={index} className="flex gap-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-sm font-medium">
                      {index + 1}
                    </span>
                    <span className="text-card-foreground">{step}</span>
                  </li>
                ))}
              </ol>
            </div>
            
            {protocol?.emergencyContact && (
              <div className="bg-error/5 border border-error/20 rounded-lg p-4">
                <div className="flex items-center gap-2 text-error mb-2">
                  <Icon name="Phone" size={18} />
                  <span className="font-semibold">Emergency Contact</span>
                </div>
                <p className="text-card-foreground">{protocol?.emergencyContact}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SafetyProtocolCard;